import * as tslib_1 from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Media, executeMediaQuery } from './Media';
import { getMaxMatch, inBetween, nothingSet, notNulls, pickMatchValues, pickMediaMatch } from "./utils";
import { MediaServerSide } from "./SSR";
var castPointsTo = function (points, targetType) { return (Object
    .keys(points)
    .reduce(function (acc, key) {
    acc[key] = targetType;
    return acc;
}, {})); };
export function createMediaMatcher(breakPoints) {
    var mediaDefaults = executeMediaQuery(breakPoints);
    var initialValue = {};
    var MediaContext = React.createContext(initialValue);
    var getMediaMatches = function (matches) { return (matches === initialValue ? mediaDefaults : matches); };
    var consume = function (cb) { return (React.createElement(MediaContext.Consumer, null, function (matched) { return cb(getMediaMatches(matched)); })); };
    function pickMatch(matches, slots) {
        return pickMediaMatch(breakPoints, matches, slots);
    }
    function useMedia(slots) {
        var matches = getMediaMatches(React.useContext(MediaContext));
        return pickMatch(matches, slots);
    }
    function pickMatchEx(matches, slots) {
        return pickMediaMatch(breakPoints, matches, slots);
    }
    var ProvideMediaMatchers = function (_a) {
        var children = _a.children, _b = _a.state, state = _b === void 0 ? null : _b;
        return (React.createElement(MediaContext.Consumer, null, function (parentMatch) {
            return React.createElement(Media, { queries: breakPoints }, function (matches) {
                var value = state || tslib_1.__assign({}, notNulls(matches), (parentMatch || {}));
                return React.createElement(MediaContext.Provider, { value: value, children: children });
            });
        }));
    };
    ProvideMediaMatchers.propTypes = process.env.NODE_ENV !== "production" ? {
        state: PropTypes.shape(tslib_1.__assign({}, castPointsTo(breakPoints, PropTypes.bool))),
    } : {};
    var MediaMatches = function (_a) {
        var children = _a.children;
        return (consume(function (matched) { return children(matched, function (matches) { return pickMatch(matched, matches); }); }));
    };
    MediaMatches.propTypes = process.env.NODE_ENV !== "production" ? {
        children: PropTypes.func.isRequired
    } : {};
    var MediaMatcher = function (props) { return (consume(function (matched) { return pickMatchEx(matched, props); })); };
    MediaMatcher.propTypes = process.env.NODE_ENV !== "production" ? tslib_1.__assign({}, castPointsTo(breakPoints, PropTypes.node)) : {};
    var InlineMediaMatcher = function (props) { return (consume(function (matched) { return pickMatchEx(matched, props); })); };
    var Mock = function (props) { return (React.createElement(MediaContext.Provider, { value: pickMatchValues(breakPoints, tslib_1.__assign({}, nothingSet(breakPoints), props)) }, props.children)); };
    var Override = function (props) { return (React.createElement(MediaContext.Consumer, null, function (parentMatch) {
        var value = tslib_1.__assign({}, notNulls(parentMatch), pickMatchValues(breakPoints, props));
        return React.createElement(MediaContext.Provider, { value: value, children: props.children });
    })); };
    var Below = function (props) { return (React.createElement(MediaMatcher, tslib_1.__assign({}, inBetween(breakPoints, props, props.children, props.including ? false : true, true)))); };
    var Above = function (props) { return (React.createElement(MediaMatcher, tslib_1.__assign({}, inBetween(breakPoints, props, props.children, props.including ? true : false, false)))); };
    var ServerRender = function (_a) {
        var predicted = _a.predicted, hydrated = _a.hydrated, children = _a.children;
        return (React.createElement(MediaContext.Provider, { value: (_b = {}, _b[predicted] = true, _b) },
            React.createElement(ProvideMediaMatchers, null,
                React.createElement(MediaContext.Consumer, null, function (matched) { return (React.createElement(MediaServerSide, { fact: getMaxMatch(breakPoints, matched), predicted: predicted, hydrated: !!hydrated, children: children })); }))));
        var _b;
    };
    return {
        pickMatch: pickMatch,
        useMedia: useMedia,
        Provider: ProvideMediaMatchers,
        Mock: Mock,
        Override: Override,
        Matches: MediaMatches,
        Inline: InlineMediaMatcher,
        Above: Above,
        Below: Below,
        Matcher: MediaMatcher,
        ServerRender: ServerRender,
        Gearbox: MediaContext.Consumer,
        Consumer: MediaContext.Consumer
    };
}
